/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface Args {
  allSelected: boolean;
  totalRecs: number;
  totalSelected: number;
  singularName: string;
}

export default class ObjectsListCount extends Component<Args> {
  get unknownTotal() {
    return this.args.totalRecs === -1;
  }
  get hideCount() {
    return this.args.totalSelected <= 0 && this.unknownTotal;
  }
}
